define(["require", "exports", "@lit/react/use-controller.js"], function (require, exports, use_controller_js_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.reactUseController = void 0;
    Object.defineProperty(exports, "reactUseController", { enumerable: true, get: function () { return use_controller_js_1.useController; } });
});
